
import { Component, Vue } from 'vue-property-decorator'
import { getAllRoutes, setRouteVisibility, adminDeleteRoute } from '@/api/userRoutes'
import RouteFormDialog from '@/components/RouteFormDialog/index.vue'

@Component({
  name: 'SavedRoutes',
  components: { RouteFormDialog }
})
export default class extends Vue {
  private createVisible = false
  private list: any[] = []
  private total = 0
  private listLoading = false
  private page = 1
  private listQuery = {
    search: '',
    visibility: '',
    limit: 20
  }

  created() {
    this.fetchList()
  }

  private async fetchList() {
    this.listLoading = true
    try {
      const res: any = await getAllRoutes({
        search: this.listQuery.search || undefined,
        visibility: this.listQuery.visibility || undefined,
        limit: this.listQuery.limit,
        offset: (this.page - 1) * this.listQuery.limit
      })
      const body = res && res.data && res.data.data
      this.list = (body && body.routes) || []
      this.total = (body && body.total) || 0
    } catch (e) {
      this.$message.error(this.$t('savedRoutes.fetchFailed') as string)
    } finally {
      this.listLoading = false
    }
  }

  private handleFilter() {
    this.page = 1
    this.fetchList()
  }

  private async toggleVisibility(row: any) {
    const target = row.visibility === 'public' ? 'private' : 'public'
    try {
      await setRouteVisibility(row.routeId, target)
      this.$message.success(this.$t('savedRoutes.visibilityUpdated') as string)
      row.visibility = target
    } catch (e) {
      this.$message.error(this.$t('savedRoutes.visibilityUpdateFailed') as string)
    }
  }

  private handleDelete(row: any) {
    this.$confirm(this.$t('savedRoutes.deleteConfirm') as string, this.$t('savedRoutes.confirmTitle') as string, { type: 'warning' })
      .then(async() => {
        try {
          await adminDeleteRoute(row.routeId)
          this.$message.success(this.$t('savedRoutes.deleted') as string)
          this.fetchList()
        } catch (e) {
          this.$message.error(this.$t('savedRoutes.deleteFailed') as string)
        }
      })
      .catch(() => { /* cancelled */ })
  }

  private formatDistance(m?: number) {
    if (m == null) return '-'
    return m >= 1000 ? (m / 1000).toFixed(1) + ' km' : m + ' m'
  }

  private formatDuration(sec?: number) {
    if (sec == null) return '-'
    const min = Math.round(sec / 60)
    return min >= 60 ? Math.floor(min / 60) + 'h ' + (min % 60) + 'm' : min + ' min'
  }

  private formatDate(d?: string) {
    if (!d) return '-'
    return new Date(d).toLocaleString()
  }
}
